import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import ImmersiveReaderButton from 'components/immersive_reader_button/immersive_reader_button'

import styles from './full_tile.scss'

class FullTile extends PureComponent {

	immersiveReaderTileTransform = () => {
		this.props.onImmersiveReaderTransform(
			this.props.content.display.value
		)
	}

	render() {
		const isImage = this.props.content.display.type === 'image'

		return (
			<div
				styleName={cn({
					wrapper: true,
					'wrapper--borderless': this.props.borderless,
				})}
				style={{
					width: this.props.tile_data.width + 'px',
					height: this.props.tile_data.height + 'px',
				}}>
				{isImage &&
					<img styleName='image' src={this.props.content.display.value} />
				||
					<Fragment>
						{ this.props.shouldShowImmersiveReader &&
							<div styleName='immersive-reader'>
								<ImmersiveReaderButton
									onClickHandler={
										this.immersiveReaderTileTransform
									}
								/>
							</div>
						}
						<div styleName='text-container'>
							<p styleName='text'>
								{this.props.content.display.value}
							</p>
						</div>
					</Fragment>
				}
			</div>
		)
	}
}

FullTile.propTypes = {
	borderless: PropTypes.bool,
	tile_data: PropTypes.object,
	content: PropTypes.object,
	onImmersiveReaderTransform: PropTypes.func,
	shouldShowImmersiveReader: PropTypes.bool,
}

FullTile.defaultProps = {
	borderless: false,
	tile_data: {},
	content: {},
	onImmersiveReaderTransform: () => {},
	shouldShowImmersiveReader: false,
}

export default CSSModules(FullTile, styles, { allowMultiple: true })
